import { getOrganizationMembers, updateMemberGroup } from '@/services/member/member'
import { Member } from '@/services/member/member.model'
import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface AddMembersModalProps extends ModalProps {
  orgId: number
  currentGroup: Member.MemberGroup
  onSuccess: () => void
}

function AddMembersModal(props: AddMembersModalProps) {
  const [isVisible, setIsVisible] = useState(true)
  const [form] = Form.useForm()
  const { orgId, currentGroup, onSuccess, ...modalProps } = props
  const { data: members = [] } = useRequest(() => getOrganizationMembers(orgId))

  const { run } = useRequest(updateMemberGroup, {
    manual: true,
    onSuccess: () => {
      setIsVisible(false)
      onSuccess?.()
    }
  })

  useEffect(() => {
    form.setFieldsValue(currentGroup)
  }, [])

  return (
    (<Modal
      {...modalProps}
      open={isVisible}
      onOk={() => {
        form.submit()
      }}
      onCancel={(e) => {
        setIsVisible(false)
        modalProps.onCancel?.(e)
      }}
    >
      <Form
        form={form}
        layout='vertical'
        onFinish={(values) => {
          run(orgId, currentGroup.id, values)
        }}
      >
        <Form.Item label='Member’s' name='memberIds'>
          <Select mode={'multiple'} showSearch>
            {members.map((member) => (
              <Select.Option key={member.memberId} value={member.memberId}>
                {member.fullName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>)
  );
}

AddMembersModal.show = (props: AddMembersModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <AddMembersModal
      {...props}
      afterClose={() => {
        props.afterClose?.()
        clean()
      }}
    />,
    div
  )
}

export default AddMembersModal
